import { useQuery } from "@tanstack/react-query"
import { getBiMetricsQuery } from "modules/backoffice/lib/bi/getBiMetricsQuery"

export function useGetBiMetricsQuery(...args: Parameters<typeof getBiMetricsQuery>) {
  return useQuery(getBiMetricsQuery(...args))
}
